/**
 * Select color by ID hash.
 * @param colors Array of colors (HEX).
 * @param id ID.
 */
export const selectColorByIdHash = (colors: string[], id: string): string => {
  let sum = 0;
  for (let i = 0; i < id.length; i++) {
    sum += id.charCodeAt(i);
  }
  return colors[sum % (colors.length - 1)];
};

/**
 * Select color by index.
 * @param colors Array of colors (HEX).
 * @param index Index.
 */
export const selectColorByIndex = (colors: string[], index: number): string => {
  return colors[index % colors.length];
};
